const getDefaultState = () => {
  return {
    courseId: undefined
  }
}

const state = getDefaultState()

const mutations = {
  SET_COUREID: (state, courseId) => {
    state.courseId = courseId
  }
}

const actions = {
  // get course info
  setCourseId ({ commit }, courseId) {
    console.log('setCourseId', courseId)

    commit('SET_COUREID', courseId)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
